import { render, staticRenderFns } from "./TravelAgency.vue?vue&type=template&id=503afbea&scoped=true"
import script from "./TravelAgency.vue?vue&type=script&lang=js"
export * from "./TravelAgency.vue?vue&type=script&lang=js"
import style0 from "./TravelAgency.vue?vue&type=style&index=0&id=503afbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503afbea",
  null
  
)

export default component.exports